// Bildnachweis: Info-Fenster über dem Bild öffnen und schließen.
// Markup: snippets/msf-bildinfo.liquid
(function () {
  function panelZu(button) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  }

  function alleZu(ausser) {
    document.querySelectorAll('.msf-bildinfo__button[aria-expanded="true"]').forEach(function (button) {
      if (button !== ausser) panelZu(button);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.msf-bildinfo__button');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      var offen = button.getAttribute('aria-expanded') === 'true';
      alleZu(button);
      panel.hidden = offen;
      button.setAttribute('aria-expanded', offen ? 'false' : 'true');
      return;
    }

    var close = event.target.closest('.msf-bildinfo__close');
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      var wrapper = close.closest('.msf-bildinfo');
      var opener = wrapper && wrapper.querySelector('.msf-bildinfo__button');
      if (opener) {
        panelZu(opener);
        opener.focus();
      }
      return;
    }

    // Klick daneben schließt das Fenster; Klicks im Fenster selbst nicht.
    if (!event.target.closest('.msf-bildinfo__panel')) alleZu(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var offen = document.querySelector('.msf-bildinfo__button[aria-expanded="true"]');
    if (!offen) return;
    panelZu(offen);
    offen.focus();
  });
})();
